import _ from "lodash";
var FPSMeter = /** @class */ (function () {
    function FPSMeter(samplesCount) {
        this.samplesCount = samplesCount;
        this.samples = [];
        this.animationFrame = null;
        this.lastTime = Date.now();
    }
    FPSMeter.prototype.tick = function () {
        var _this = this;
        var now = Date.now();
        this.samples.push(now - this.lastTime);
        this.lastTime = now;
        while (this.samples.length > this.samplesCount) {
            this.samples.shift();
        }
        this.animationFrame = requestAnimationFrame(function () { return _this.tick(); });
    };
    FPSMeter.prototype.getFps = function () {
        var avgInterval = _.mean(this.samples);
        return 1000 / avgInterval;
    };
    FPSMeter.prototype.start = function () {
        var _this = this;
        if (this.animationFrame != null)
            return;
        this.lastTime = Date.now();
        this.animationFrame = requestAnimationFrame(function () { return _this.tick(); });
    };
    FPSMeter.prototype.stop = function () {
        if (this.animationFrame == null)
            return;
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
    };
    return FPSMeter;
}());
export { FPSMeter };
var FPSMonitor = /** @class */ (function () {
    function FPSMonitor(fps, threshold, duration) {
        this.fps = fps;
        this.threshold = threshold;
        this.duration = duration;
        this.interval = null;
        this.timeUnderThreshold = 0;
    }
    FPSMonitor.prototype.start = function () {
        var _this = this;
        if (this.interval != null)
            return;
        this.interval = setInterval(function () {
            var _a;
            var fps = _this.fps.getFps();
            if (fps < _this.threshold) {
                _this.timeUnderThreshold += 1000;
            }
            if (_this.timeUnderThreshold >= _this.duration) {
                _this.stop();
                (_a = _this.onUnderThreshold) === null || _a === void 0 ? void 0 : _a.call(_this);
            }
        }, 1000);
    };
    FPSMonitor.prototype.stop = function () {
        if (this.interval == null)
            return;
        clearInterval(this.interval);
        this.interval = null;
    };
    return FPSMonitor;
}());
export { FPSMonitor };
